module.exports = __webpack_public_path__ + "img/networkLicense.ca4262f9.png";